import React, { useEffect, useState } from "react";
import { eventService } from "../../api/eventService";

const UpcomingEvents = () => {
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const parseDateSafe = (value) => {
        if (!value) return null;
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    };

    const formatDateSafe = (dateObj, options) => {
        if (dateObj instanceof Date && !isNaN(dateObj.getTime())) {
            return dateObj.toLocaleDateString("en-US", options);
        }
        // fallback if we don't have a valid Date object:
        return dateObj || "N/A";
    };

    const fetchUpcomingEvents = async () => {
        try {
            setLoading(true);

            const response = await eventService.GetDashboardEvent();
            //console.log("Upcoming Events API:", response);

            if (
                response?.Message?.[0]?.RETURNCODE === "1" &&
                Array.isArray(response.UpcomingEvent) &&
                response.UpcomingEvent.length > 0
            ) {
                const ev = response.UpcomingEvent[0];

                // parse dates safely
                const startDateObj = parseDateSafe(ev.EventStartDate);
                const endDateObj = parseDateSafe(ev.EventEndDate);

                const formattedEvent = {
                    id: ev.Event_ID,
                    title: ev.EventName,
                    image: ev.EventImage,
                    // keep both raw Date objects (or null) and original strings if needed
                    startDateObj,
                    endDateObj,
                    startDateRaw: ev.EventStartDate,
                    endDateRaw: ev.EventEndDate,
                    startTime: ev.EventStartTime,
                    endTime: ev.EventEndTime,
                    location: ev.EventPlace || "N/A",
                    shortDesc: ev.EventShortDescription,
                    longDesc: ev.EventLongDescription,
                    buttonText: ev.ButtonText || "Book Appointment",
                    eventUrl: ev.FormURL,
                };

                setEvent(formattedEvent);
            } else {
                throw new Error("Invalid API response");
            }
        } catch (err) {
            console.error("Error fetching events:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUpcomingEvents();
    }, []);

    if (loading) {
        return (
            <section className="py-5 text-center">
                <div className="spinner-border" style={{ width: "3rem", height: "3rem" }}></div>
                <p className="mt-3">Loading upcoming events...</p>
            </section>
        );
    }

    //if (error && event.length === 0) {
    //    return (
    //        <section className="py-5 text-center text-danger">
    //            <h4> Unable to fetch trending blogs</h4>
    //            <p>{error}</p>
    //            <button className="btn btn-primary mt-3" onClick={fetchUpcomingEvents}>
    //                Retry
    //            </button>
    //        </section>
    //    );
    //}

    if (!event) {
        return (
            <section className="py-5 text-center text-danger">
                <h4>Unable to load event</h4>
                <button className="btn btn-primary mt-3" onClick={fetchUpcomingEvents}>
                    Retry
                </button>
            </section>
        );
    }

    // Format date range for UI using safe formatter:
    //const formattedStart = formatDateSafe(event.startDateObj, {
    //    month: "short",
    //    day: "numeric",
    //});

    const formattedStart = event?.startDateObj
        ? formatDateSafe(event.startDateObj, { month: "short", day: "numeric" })
        : "";

    //const formattedEnd = formatDateSafe(event.endDateObj, {
    //    month: "short",
    //    day: "numeric",
    //    year: "numeric",
    //});

    const formattedEnd = event?.endDateObj
        ? formatDateSafe(event.endDateObj, { month: "short", day: "numeric", year: "numeric" })
        : "";

    let formattedDateRange;

    if (formattedStart === "N/A" && formattedEnd === "N/A") {
        formattedDateRange = event.startDateRaw || event.endDateRaw || "Date not available";
    } else if (formattedEnd && formattedStart !== formattedEnd) {
        formattedDateRange = `${formattedStart} - ${formattedEnd}`;
    } else {
        formattedDateRange = formattedStart;
    }

    return (
        <section
            className="full-bg-section d-flex align-items-center position-relative py-5"
            style={{
                backgroundImage:
                    "url('/assets/images/Home/labgrown-bg.jpg'), url('/assets/images/Home/Event-bg.png')",
                backgroundSize: "cover, cover",
                backgroundPosition: "bottom, bottom",
                backgroundRepeat: "no-repeat, no-repeat",
                backgroundAttachment: "scroll, scroll",
                backgroundBlendMode: "hard-light",
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                minHeight: "60vh",
            }}
        >
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row align-items-center flex-column-reverse flex-md-row">

                    {/* Left: Image */}
                    <div className="col-12 col-md-6 text-center mt-4 mt-md-0" data-aos="slide-right">
                        <img
                            src={event.image}
                            alt={event.title}
                            className="img-fluid shadow"
                            style={{
                                width: "100%",
                                maxWidth: "650px",
                                maxHeight: "500px",
                                objectFit: "cover",
                            }}
                            onError={(e) => (e.target.src = "/assets/images/Home/labgrown2.jpg")}
                        />
                    </div>

                    {/* Right: Event Info */}
                    <div
                        className="col-12 col-md-6 text-center text-lg-center text-md-start text-white"
                        data-aos="slide-left"
                    >
                        <h2 className="display-5 fw-bold text-white">{event.title}</h2>

                        <p className="mt-2 fs-5">
                            {formattedDateRange} • {event.location}
                        </p>

                        {event.eventUrl && (
                            <a href={event.eventUrl} target="_blank" rel="noopener noreferrer">
                                <button className="primary-button-quality mt-3">
                                    {event.buttonText}
                                </button>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );

};

export default UpcomingEvents;
